import { BiUtils, getSearchParams, wixServerData } from '@wix/package-picker-shared';
import { v4 } from 'uuid';
import { useCurrentModule } from '../../components';
const biEventAggregator = v4();
const getBiFlowType = isSwitchFlow => {
  if (isSwitchFlow) {
    const {
      isDowngradeEnabled
    } = getSearchParams();
    if (isDowngradeEnabled) {
      return 'downgrade';
    }
    return 'upgrade';
  }
  return 'purchase';
};
export const useCommonBiEventsFields = function (_temp) {
  var _currentProductStatus, _currentProductStatus2, _isSwitchFlowQuery$da, _currentProductQuery$;
  let {
    enabled = true
  } = _temp === void 0 ? {
    enabled: true
  } : _temp;
  const module = useCurrentModule();
  const {
    referralAdditionalInfo,
    siteGuid
  } = getSearchParams();
  const {
    referrer
  } = wixServerData.get();
  const currentProductStatusQuery = module.SDK.switchApiClient.hooks.useGetCurrentProductStatus({}, enabled);
  const isSwitchFlowQuery = module.SDK.switchApiClient.hooks.useIsSwitchFlow({}, enabled);
  const currentProductQuery = module.SDK.switchApiClient.hooks.useGetCurrentProduct({}, enabled);
  const changePlanType = BiUtils.getBiChangePlanType((_currentProductStatus = currentProductStatusQuery.data) == null ? void 0 : _currentProductStatus.status);
  const commonBiEventsFields = {
    abTesting: 'purchase_wix_plan_static',
    packagePickerType: 'studio',
    project: 'package-picker-studio',
    eventAggregator: biEventAggregator,
    referralAdditionalInfo,
    referrer,
    siteGuid,
    siteId: siteGuid,
    msid: siteGuid,
    newPurchase: ((_currentProductStatus2 = currentProductStatusQuery.data) == null ? void 0 : _currentProductStatus2.status) === 'noCurrentProduct' ? 'true' : 'false',
    changePlanType,
    flowType: getBiFlowType((_isSwitchFlowQuery$da = isSwitchFlowQuery.data) == null ? void 0 : _isSwitchFlowQuery$da.isSwitchFlow),
    currentProductGuid: (_currentProductQuery$ = currentProductQuery.data) == null || (_currentProductQuery$ = _currentProductQuery$.currentProduct) == null ? void 0 : _currentProductQuery$.productId,
    cartFlow: 'classic',
    ppType: 'business',
    intent: 'Default'
  };
  const isLoading = currentProductStatusQuery.isLoading || currentProductQuery.isLoading || isSwitchFlowQuery.isLoading;
  return {
    commonBiEventsFields,
    isLoading,
    enabled
  };
};
//# sourceMappingURL=useCommonBiEventsFields.js.map